import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { divideGameListToSlides, getCategory } from '@/logic/main/utils';
import { BINGO_GAMES_ID } from '@/model/constants';
import Window from '@/ports-frontend/Window';
import { CategoryGameGridType } from '@/types/category/categoryTypes';
import { getLocale } from '@/utils';

export const getLiveGamesContent = async (context: LogicContext) => {
  const {
    shuffleGames,
    multiJackpots,
    currentJackpotsV2,
    currentTables,
    currentPersonalizedBanners,
    controllersData,
    user,
    strikeGoldData,
    pageMainTitle,
  } = context;
  const locale = getLocale(config);
  const currency = user?.currency || config.default_currency;
  const loggedIn = Boolean(user?.loggedIn);
  const { drawnGame } = shuffleGames;
  if (!controllersData?.liveGamesContent) {
    return {
      updates: [],
    };
  }
  const windowInnerWidth = await Window.getInnerWidth();
  const gameDetailsInfo = config.features.gameDetails.mode === 'enabled';

  const updates = controllersData.liveGamesContent.components.map(
    ([id, entry]) => {
      const content: (CategoryGameGridType | any)[] = [];

      entry.properties.pageContent.forEach(element => {
        if (element.component_type === 'bingo_games') {
          if (!context.bingoGames?.length) return;

          const category = ({
            id: BINGO_GAMES_ID,
            view_all_button_visible: false,
            title: element.title,
            games: context.bingoGames,
            gameDetailsInfo,
            staticTexts: {
              bingoTimer: {
                starting: element.bingoStaticTexts?.timer?.starting,
                closed: element.bingoStaticTexts?.timer?.closed,
              },
            },
            type: 'Extended Single Block',
            component_type: element.component_type,
            slides: divideGameListToSlides({
              gameList: context.bingoGames,
              slideType: 'Extended Single Block',
            }),
          } as unknown) as CategoryGameGridType;

          content.push(
            getCategory({
              category,
              shuffleGame: drawnGame,
              strikeGoldData,
            })
          );
          return;
        }

        content.push(
          getCategory({
            category: {
              ...element,
            },
            multiJackpots,
            currentJackpotsV2,
            currentTables,
            currentPersonalizedBanners,
            shuffleGame: drawnGame,
            windowInnerWidth,
            currency,
            locale,
            strikeGoldData,
          })
        );
      });

      return {
        type: 'setLayoutProperty',
        data: {
          path: `components.${id}.properties`,
          value: {
            pageTitle: pageMainTitle,
            pageContent: content,
            loggedIn,
            visible: !context.isGameModalForMobileOpened,
          },
        },
      };
    }
  );

  return {
    updates,
  };
};
